import {useNuxtApp} from '#app';
import type {Logger} from '../types';

export function useLogger(): Logger {
    return useNuxtApp().$logger as Logger;
}
